<jhi-spinner *ngIf="loading"></jhi-spinner>
<jhi-alert></jhi-alert>
<div class="container-fluid">
  <!-- <a class="go-back" (click)="goToListaAppuntamenti()">
    <svg class="icon icon-sm me-2 icon-black">
      <use href="content/svg/sprites.svg#it-arrow-left"></use>
    </svg>
    <span jhiTranslate="istanze.tornaIndietro">Torna indietro</span>
  </a> -->
</div>
<div class="col-xl">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body mt-0">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
            <li class="breadcrumb-item" *ngIf="checkDirettoCruscotto()"><a href="javascript:void(0)" (click)="goToCruscotto()">Cassetto del cittadino</a><span class="separator">/</span></li>
            <li class="breadcrumb-item" *ngIf="!checkDirettoCruscotto()"><a href="javascript:void(0)" (click)="goToListaAppuntamenti()">Lista prenotazioni</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Dettaglio appuntamento</a></li>
          </ol>
        </nav>
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-xl-5 col-lg-8 col-md-10 mb-3">
              <div
                class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
                style="justify-content: space-around"
              >
                <div class="card-image-wrapper with-read-more">
                  <div class="card-body">
                    <h3 class="card-title h5" jhiTranslate="riepilogoAppuntamento.Dichiarante">Dichiarante</h3>
                    <div class="card border-black border-top">
                      <br/><br/>

                      <div class="form-group row">
                        <div class="col-6">
                          <label for="nomeUtente" class="active" jhiTranslate="form.nome">Nome</label>
                          <input
                            disabled
                            readonly
                            id="nomeUtente"
                            class="form-control"
                            type="text"
                            value="{{ sessionAppuntamento?.dichiarante?.nome }}"
                          />
                        </div>

                        <div class="col-6">
                          <label for="cognomeUtente" class="active" jhiTranslate="form.cognome">Cognome</label>
                          <input
                            disabled
                            readonly
                            id="cognomeUtente"
                            class="form-control"
                            type="text"
                            value="{{ sessionAppuntamento?.dichiarante?.cognome }}"
                          />
                        </div>
                      </div>

                      <div *ngIf="sessionAppuntamento?.dichiarante?.cf" class="form-group">
                        <label for="CFUtente" class="active" jhiTranslate="form.cf">CF</label>
                        <input
                          disabled
                          readonly
                          id="CFUtente"
                          class="form-control"
                          type="text"
                          value="{{ sessionAppuntamento?.dichiarante?.cf }}"
                        />
                      </div>

                      <div *ngIf="sessionAppuntamento?.dichiarante?.email" class="form-group">
                        <label for="emailUtente" class="active" jhiTranslate="form.email">E-mail</label>
                        <input
                          disabled
                          readonly
                          id="emailUtente"
                          class="form-control"
                          type="text"
                          value="{{ sessionAppuntamento?.dichiarante?.email }}"
                        />
                      </div>

                      <div *ngIf="sessionAppuntamento?.dichiarante?.tel" class="form-group">
                        <label for="telefonoUtente" class="active" jhiTranslate="form.numTel">Numero di Telefono</label>
                        <input
                          disabled
                          readonly
                          id="telefonoUtente"
                          class="form-control"
                          type="text"
                          value="{{ sessionAppuntamento?.dichiarante?.tel }}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-5 col-lg-8 col-md-10 mb-3">
              <div
                class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
                style="justify-content: space-around"
              >
                <div class="card-image-wrapper with-read-more">
                  <div class="card-body">
                    <h3 class="card-title h5" jhiTranslate="riepilogoAppuntamento.appuntamentoPreso">Appuntamento preso
                      da</h3>
                    <div class="card border-black border-top">
                      <br/><br/>

                      <div class="form-group row">
                        <div class="col-6">
                          <label for="nomeRichiedente" class="active" jhiTranslate="form.nome">Nome</label>
                          <input
                            disabled
                            readonly
                            id="nomeRichiedente"
                            class="form-control"
                            type="text"
                            value="{{ sessionAppuntamento?.richiedente?.nome }}"
                          />
                        </div>

                        <div class="col-6">
                          <label for="cognomeRichiedente" class="active" jhiTranslate="form.cognome">Cognome</label>
                          <input
                            disabled
                            readonly
                            id="cognomeRichiedente"
                            class="form-control"
                            type="text"
                            value="{{ sessionAppuntamento?.richiedente?.cognome }}"
                          />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="CFRichiedente" class="active"
                               jhiTranslate="form.cf">CF</label>
                        <input
                          disabled
                          readonly
                          id="CFRichiedente"
                          class="form-control"
                          type="text"
                          value="{{ sessionAppuntamento?.richiedente?.cf }}"
                        />
                      </div>

                      <div *ngIf="sessionAppuntamento?.richiedente?.email" class="form-group">
                        <label for="emailRichiedente" class="active" jhiTranslate="form.email">E-mail</label>
                        <input
                          disabled
                          readonly
                          id="emailRichiedente"
                          class="form-control"
                          type="text"
                          value="{{ sessionAppuntamento?.richiedente?.email }}"
                        />
                      </div>

                      <div *ngIf="sessionAppuntamento?.richiedente?.tel" class="form-group">
                        <label for="telefonoRichiedente" class="active" jhiTranslate="form.numTel">Numero di
                          Telefono</label>
                        <input
                          disabled
                          readonly
                          id="telefonoRichiedente"
                          class="form-control"
                          type="text"
                          value="{{ sessionAppuntamento?.richiedente?.tel }}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-5 col-lg-8 col-md-10 mb-3">
              <!-- *ngIf="operatore[0]?.id" -->
              <div #_CARD_OPERATORE>
                <div
                  class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
                  style="justify-content: space-around"
                >
                  <div class="card-image-wrapper with-read-more">
                    <div class="card-body">
                      <h3 class="card-title h5" jhiTranslate="riepilogoAppuntamento.datiOperatore">Dati Operatore</h3>
                      <div class="card border-black border-top">
                        <br/><br/>

                        <div class="form-group row">
                          <div class="col-6">
                            <label for="nomeOperatore" class="active" jhiTranslate="riepilogoAppuntamento.nomeOperatore"
                            >Nome Operatore</label
                            >
                            <input
                              disabled
                              readonly
                              id="nomeOperatore"
                              class="form-control"
                              type="text"
                              value="{{ sessionAppuntamento?.dipendente?.nmNome }}"
                            />
                          </div>

                          <div class="col-6">
                            <label for="cognomeOperatore" class="active"
                                   jhiTranslate="riepilogoAppuntamento.cognomeOperatore"
                            >Cognome Operatore</label
                            >
                            <input
                              disabled
                              readonly
                              id="cognomeOperatore"
                              class="form-control"
                              type="text"
                              value="{{ sessionAppuntamento?.dipendente?.nmCognome }}"
                            />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="matricolaOperatore" class="active" jhiTranslate="riepilogoAppuntamento.matricola">Matricola</label>
                          <input
                            disabled
                            readonly
                            id="matricolaOperatore"
                            class="form-control"
                            type="text"
                            value="{{ sessionAppuntamento?.dipendente?.matricola }}"
                          />
                        </div>

                        <div class="row" style="margin-bottom: 95px"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-5 col-lg-8 col-md-10 mb-3">
              <div
                class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
                style="justify-content: space-around"
              >
                <div class="card-image-wrapper with-read-more">
                  <div class="card-body">
                    <h3 class="card-title h5" jhiTranslate="riepilogoAppuntamento.dettaglioUfficio">Dettaglio
                      Ufficio</h3>
                    <div class="card border-black border-top">
                      <br/><br/>
                      <div class="form-group">
                        <label class="active" for="hhInizio"
                               jhiTranslate="riepilogoAppuntamento.nomeServizio">Servizio</label>
                        <input
                          disabled
                          readonly
                          type="text"
                          class="form-control"
                          id="nmServizio"
                          value="{{ sessionAppuntamento?.content?.servizioErogato?.servizio?.nmServizio }}"
                        />
                      </div>

                      <div class="form-group row">
                        <div class="col">
                          <label class="active" for="hhFine"
                                 jhiTranslate="riepilogoAppuntamento.nomeUfficio">Ufficio</label>
                          <input
                            disabled
                            readonly
                            type="text"
                            class="form-control"
                            id="nmUfficio"
                            value="{{ sessionAppuntamento?.content?.servizioErogato?.ufficio?.nmUfficio }}"
                          />
                        </div>

                        <div class="col">
                          <label class="active" for="dataApp" jhiTranslate="riepilogoAppuntamento.nomeSede">Sede</label>
                          <input
                            disabled
                            readonly
                            type="text"
                            class="form-control"
                            id="nmSede"
                            value="{{ sessionAppuntamento?.content?.servizioErogato?.servizio?.nmServizio }}"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="active" for="stato"
                               jhiTranslate="riepilogoAppuntamento.indirizzoSede">Indirizzo</label>
                        <input
                          disabled
                          readonly
                          type="text"
                          class="form-control"
                          id="dlIndirizzo"
                          value="{{ sessionAppuntamento?.content?.servizioErogato?.ufficio?.sede?.dlIndirizzo }}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center p-0">
              <div class="col-xl-10 col-lg-8 col-md-10">
                <!--col-xl-5 col-lg-8 col-md-10 -->
                <div
                  class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
                  style="justify-content: space-around"
                >
                  <div class="card-image-wrapper with-read-more">
                    <div class="card-body">
                      <h3 class="card-title h5 mb-1" jhiTranslate="riepilogoAppuntamento.riepilogoAppuntamentoTitolo">
                        Riepilogo Appuntamento
                      </h3>

                      <div class="mb-4">
                        Codice Appuntamento:&nbsp;<span
                        class="primaryTextColor">{{ sessionAppuntamento?.content?.cdPrenotazione }}</span>
                      </div>

                      <div class="card">
                        <br/><br/>

                        <div class="row form-group">
                          <div class="col">
                            <label class="active" for="dataApp">Data Appuntamento</label>
                            <input
                              disabled
                              readonly
                              type="text"
                              class="form-control"
                              id="dataApp"
                              value="{{ sessionAppuntamento?.content?.dataPrenotazione | date: 'dd/MM/yyyy' }} {{ formatTime(sessionAppuntamento?.content?.hhInizio) }} - {{ formatTime(sessionAppuntamento?.content?.hhFine) }}"
                            />
                          </div>
                          <div class="col">
                            <label class="active" for="stato">Stato Appuntamento</label>
                            <input
                              disabled
                              readonly
                              type="text"
                              class="form-control"
                              id="stato"
                              value="{{ sessionAppuntamento?.content?.tiStato }}"
                            />
                          </div>
                        </div>

                        <div class="row form-group">
                          <div class="col">
                            <label class="active" for="emailAppuntamento">Email</label>
                            <input
                              disabled
                              readonly
                              type="text"
                              class="form-control"
                              id="emailAppuntamento"
                              value="{{ sessionAppuntamento?.content?.email }}"
                            />
                          </div>

                          <div class="col">
                            <label class="active" for="telAppuntamento">Telefono</label>
                            <input
                              disabled
                              readonly
                              type="text"
                              class="form-control"
                              id="telAppuntamento"
                              value="{{ sessionAppuntamento?.content?.tel }}"
                            />
                          </div>
                        </div>

                        <div class="row form-group">
                          <div class="col">
                            <label class="active" for="telAppuntamento">Note</label>
                            <textarea
                              disabled
                              readonly
                              #_TEXTAREA_NOTE
                              class="form-control customTextArea readonly disabled fw-bold"
                              id="note"
                            >{{ sessionAppuntamento?.content?.deNote }}</textarea
                            >
                          </div>
                        </div>
                        <div class="form-group mt-1">
                          <div class="row gap-xl-0 gap-md-0 gap-sm-0 gap-lg-0 gap-5">
                            <!--Bottone 3 -->
                            <div class="col-12">
                              <span>
                                <button
                                  (click)="formPatchValueAnnullato(sessionAppuntamento?.content?.id)"
                                  class="btn btn-primary btn-xs"
                                  data-container="body"
                                  style="background-color: red"
                                  data-bs-toggle="modal"
                                  data-bs-target="#modal2"
                                  data-bs-trigger="hover"
                                  data-bs-placement="top"
                                  data-html="true"
                                  title="Annulla appuntamento"
                                  data-bs-content="Annulla appuntamento 2"
                                  [disabled]="lineLoading"
                                  *ngIf="
                                    sessionAppuntamento?.content?.tiStato !== 'Annullato' &&
                                    sessionAppuntamento?.content?.tiStato !== 'Conseguito' &&
                                    sessionAppuntamento?.content?.tiStato !== 'Trasferito' &&
                                    sessionAppuntamento?.content?.flCancellazione
                                  "
                                >
                                  Cancella
                                </button>
                              </span>
                              <div class="modal fade" tabindex="-1" role="dialog" id="modal2"
                                   aria-labelledby="modalCenterTitle">
                                <div class="modal-dialog modal-dialog-centered" role="document">
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h2 class="modal-title h5 no_toc" id="modalCenterTitle2">Annullare
                                        l'appuntamento?</h2>
                                      <button class="btn-close" type="button" data-bs-dismiss="modal"
                                              aria-label="Chiudi finestra modale">
                                        <svg class="icon">
                                          <use href="./content/svg/sprites.svg#it-close"></use>
                                        </svg>
                                      </button>
                                    </div>
                                    <div class="modal-body" style="text-align: left">
                                      <p>Premere il pulsante conferma per annullare l'appuntamento.</p>
                                    </div>
                                    <div class="modal-footer">
                                      <button class="btn btn-outline-primary btn-sm" type="button"
                                              data-bs-dismiss="modal">
                                        <span jhiTranslate="modale.annulla">Annulla</span>
                                      </button>
                                      <button
                                        (click)="formPatchValueAnnullato(sessionAppuntamento?.content?.id); changeStatoAppuntamento()"
                                        class="btn btn-primary btn-sm"
                                        type="button"
                                        data-bs-dismiss="modal"
                                      >
                                        <span jhiTranslate="modale.conferma">Conferma</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="bgModale"></div>
  </div>
</div>
